/* Which optional channels this installation actually has.
 *
 * One public document, `config/notifications`, world-readable and
 * client-unwritable (see firestore.rules). Today it answers exactly one
 * question: is there something on the other end of the mail queue?
 *
 * The alternative was a build-time flag, and it is worse in the way that
 * matters: sending email needs a Firebase Extension installed against real
 * SMTP credentials, which is an operations act, not a deploy. A flag in the
 * bundle would mean the day the extension goes in, the app still says no until
 * someone remembers to rebuild — and the day it is removed, the app keeps
 * promising email nobody can send. Reading it from Firestore is the same
 * pattern the course catalog already uses: change the answer, no redeploy.
 *
 * Absent, unreadable, offline, or Firebase not configured at all → false.
 * "We cannot tell" and "no" have the same correct behaviour here: don't offer
 * it. That is also why this is a promise the UI awaits rather than a default
 * it renders and corrects — a toggle that appears and then vanishes is worse
 * than one that appears a beat late.
 */
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase.js";

let pending = null;

export function appConfig() {
  if (!pending) {
    pending = (async () => {
      if (!db) return {};
      try {
        const snap = await getDoc(doc(db, "config", "notifications"));
        return snap.exists() ? snap.data() : {};
      } catch {
        return {};
      }
    })();
  }
  return pending;
}

export const emailDeliveryAvailable = () => appConfig().then((c) => c.email === true);
